__turbopack_context__.v({
  "main": "CurrentLocation-module-scss-module__djeyUq__main",
  "text": "CurrentLocation-module-scss-module__djeyUq__text",
});
